import { getContactUploadStatus } from '../graphql/queries';
import { getContactUploadUrl, registerContactUpload } from '../graphql/mutations';
import { axiosRequest } from '../utils/axiosRequest';
import { Auth } from 'aws-amplify';

const contactsService = {
  getHeaders: async () => {
    const session = await Auth.currentSession();
    const jwt = session.getIdToken().getJwtToken();
    return {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Authorization: jwt,
    };
  },

  issueRequest: async (body) => {
    const headers = await contactsService.getHeaders();
    const method = 'post';
    const options = { headers, body, method: method };

    return await axiosRequest(options);
  },

  getUploadUrl: async (fileName, uploadType) => {
    const body = {
      query: getContactUploadUrl,
      variables: { fileName, uploadType },
    };

    const res = await contactsService.issueRequest(body);
    return res.data?.data?.getContactUploadUrl;
  },

  registerUpload: async (uploadId, rowCount) => {
    const body = {
      query: registerContactUpload,
      variables: { uploadId, rowCount },
    };

    const res = await contactsService.issueRequest(body);
    return res.data?.data?.registerContactUpload;
  },

  pollUploadStatus: async (uploadId) => {
    const body = {
      query: getContactUploadStatus,
      variables: { uploadId },
    };

    const res = await contactsService.issueRequest(body);
    return res.data?.data?.getContactUploadStatus;
  },
};

export default contactsService;
